import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

import { typographyDefinition } from "../../theme/typography";
import { responsive } from "../../utils/responsive";

export const headingStyle = style({
  // Keep
});

export const titleContainerStyle = recipe({
  base: {
    width: "100%",
  },
  variants: {
    variant: {
      main: { maxWidth: rem(640) },
      default: { maxWidth: rem(640) },
      secondary: { maxWidth: rem(640) },
      card: {},
    },
    forceStretch: {
      true: {
        maxWidth: "none !important",
      },
    },
  },
});

export const titleStyle = recipe({
  base: {
    fontWeight: "bold",
  },
  variants: {
    variant: {
      main: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...(typographyDefinition.header as any),
      },
      default: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...(typographyDefinition.displayM as any),
        fontWeight: "bold",
      },
      secondary: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...(typographyDefinition.displayL as any),
        fontWeight: "bold",
      },
      card: {
        fontWeight: "bold",
      },
    },
  },
});

export const descriptionStyle = recipe({
  base: {
    maxWidth: rem(640),
  },
  variants: {
    variant: {
      main: {
        ...responsive({
          s: {
            ...typographyDefinition.bodyL,
          },
        }),
      },
      secondary: {},
      default: {},
      card: {},
    },
  },
});
